export enum SmartTestType {
  Short = 'SHORT',
  Long = 'LONG',
  Conveyance = 'CONVEYANCE',
  Offline = 'OFFLINE',
}
